import React, { useEffect, useState } from 'react';
import '../../../styles/components/KnowledgeCentre/KnowledgeCentre.scss';
import Slider from 'react-slick';
import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
// Import css files
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import ModalVideo from 'react-modal-video';
import { ConstructionOutlined } from '@mui/icons-material';
import KnowledgeCentreConstants, { VIEW_TYPES } from '../../../constants/MitraContentConstants';

import DialolPopup from './DialogPopup';
import Play from '../../../assets/play.png';

import VideoService from '../../../services/VideoService';
import MyJobsFooter from '../../MyJobsStatus/components/MyJobsFooter';
import useMoengage from '../../../hooks/useMoengage';

const PAGE_TITLE = 'Knowledge Centre';
const MODE = 'Whatsapp';
const ANALYTICS_EVENTS = {
  WATCH_VIDEO_CLICK: 'watch_video_click',
  ARTICLE_SHARE_BUTTON_CLICK: 'article_shared',
  VIDEO_SHARE_BUTTON_CLICK: 'video_shared',
  VIDEO_LIKE_BUTTON_CLICK: 'video_liked',
  ARTICLE_LIKE_BUTTON_CLICK: 'article_liked',
  VIDEO_PLAYED: 'video_played',
  ARTICLE_VIEWED: 'article_viewed',
};

export default function ArticleView(props) {
  const { article, likedItems, getUpdatedSelectedLikeButton, handleClickShare } = props;
  const [, , triggerContentInteractedEvent] = useMoengage();

  return (
    <div
      style={{
        marginTop: '50px',
      }}
    >
      <Card sx={{ maxWidth: '100%' }}>
        <Link
          href={article.url}
          target="_blank"
          underline="none"
          color="inherit"
          onClick={() => {
            triggerContentInteractedEvent(ANALYTICS_EVENTS.ARTICLE_VIEWED, {
              content_url:article.url,
              container_position: article.containerPosition,
            });
          }}
        >
          <CardMedia
            component="img"
            height="181"
            image={article.imageSrc}
            alt="green iguana"
            className="slider_image2"
          />
        </Link>
        <CardContent>
          <Typography
            style={{
              fontSize: '17px',
            }}
            gutterBottom
            variant="p"
            component="div"
          >
            {article.title}
          </Typography>

          <Typography
            style={{
              fontSize: '11px',
            }}
            variant="body2"
            color="text.secondary"
          >
            {article.description}
          </Typography>
        </CardContent>
        <CardActions
          style={{
            marginTop: '-10px',
            float: 'right',
          }}
        >
          <IconButton
            aria-label="like"
            style={{
              color: likedItems.includes(article.id) ? 'orange' : 'black',
            }}
            onClick={() => {
              triggerContentInteractedEvent(ANALYTICS_EVENTS.ARTICLE_LIKE_BUTTON_CLICK, {
                content_url:article.url,
                container_position: article.containerPosition,
              });
              getUpdatedSelectedLikeButton(article.id);
            }}
          >
            <ThumbUpIcon />
          </IconButton>

          <IconButton
            aria-label="share"
            style={{ color: 'black' }}
            color="primary"
            onClick={() => {
              handleClickShare(article, VIEW_TYPES.ARTICLE);
            }}
          >
            <ShareIcon />
          </IconButton>
        </CardActions>
      </Card>
    </div>
  );
}
